import React, { useState, useEffect } from 'react';
import { EditText, EditDropDown } from 'components/EditText/EditText';
import { get, post, dodelete, put } from 'lib/comms';
import { DeleteDialog, MessageDialog, ColourPickerDialog } from 'components/Dialog/Dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as SolidIcons from '@fortawesome/free-solid-svg-icons';
import * as RegularIcons from '@fortawesome/free-regular-svg-icons';
import { faPlusCircle, faSearch, faTimes, faEyeDropper } from '@fortawesome/free-solid-svg-icons';
import './KnowledgebasePage.css';
import styled from 'styled-components';
import FeatureFlagService from 'services/FeatureFlagService';

export default class KnowledgebaseCategories extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            addingCategory: false,
            editCategoryName: '',
            newCategoryName: '',
            newIconNameString: null,
            newiconColour: null,
            editiconNameString: null,
            editiconColour: '',
            editingCategoryId: null,
            showMessage: '',
            showCategoryIconDialog: false,
        };
    }

    componentDidMount = () => {
        this.reload();
    };

    reload = async () => {
        let resp = await get('cms/knowledgebase_categories', null, true);
        if (resp && resp.status === 401) this.setState({ logout: true });
        const categories = resp && resp.categories ? resp.categories : [];

        this.setState({
            categories: categories.sort((a, b) => (a.isDefault ? -1 : 1)),
        });
    };

    resetEditingCategory = () => {
        this.setState({ editingCategoryId: null, editCategoryName: '' });
    };

    openAddingCategory = () => {
        this.setState({
            addingCategory: true,
            newCategoryName: '',
            editCategoryName: null,
            editingCategoryId: '',
        });
    };

    closeAddingCategory = () => {
        this.setState({
            addingCategory: false,
        });
    };

    openEditingCategory = (editingCategoryId, categoryName) => {
        this.setState({
            editingCategoryId,
            editCategoryName: categoryName,
        });
    };

    saveNewCategory = async () => {
        let { newCategoryName, newIconNameString, newiconColour } = this.state;
        if (!newCategoryName || !newCategoryName.trim()) {
            this.setState({
                showMessage: {
                    message: 'Please enter a valid name',
                    title: 'Save Error',
                    close: () => this.setState({ showMessage: null }),
                },
            });
            return;
        }
        const existingCat = this.state.categories.filter((category) => category.name === newCategoryName);
        if (existingCat.length > 0) {
            this.showErrorDialog('Category already exists');
            return;
        }
        const resp = await post(
            'cms/knowledgebase_categories',
            { name: newCategoryName, icon_name: newIconNameString, icon_colour: newiconColour },
            true,
        );
        if (resp && resp.success) {
            this.setState({ newCategoryName: null, addingCategory: false });
            this.reload();
        } else {
            resp.message && this.showErrorDialog(resp.message);
        }
    };

    deleteCategory = async (categoryId) => {
        const resp = await dodelete(`cms/knowledgebase_categories/${categoryId}`, {}, true);
        if (resp && resp.success) {
            this.reload();
        } else if (resp.message) {
            setTimeout(
                () =>
                    this.setState({
                        showMessage: { message: resp.message, title: 'Delete Category' },
                    }),
                500,
            );
        }
    };

    saveEditedCategory = async () => {
        const { editCategoryName, editiconNameString, editIconColour, editingCategoryId, categories } = this.state;

        const currentCategory = categories.find((c) => c.id === editingCategoryId);
        const nameToSave = editCategoryName ?? currentCategory?.name;
        const iconToSave = editiconNameString ?? currentCategory?.icon_name;
        const colourToSave = editIconColour ?? currentCategory?.icon_colour;

        const existingCat = categories.find(
            (category) => category.name === nameToSave && category.id !== editingCategoryId,
        );

        if (existingCat) {
            this.showErrorDialog('Category already exists');
            return;
        }

        const resp = await put(
            `cms/knowledgebase_categories/${editingCategoryId}`,
            {
                name: nameToSave,
                icon_name: iconToSave,
                icon_colour: colourToSave,
            },
            true,
        );
        if (resp && resp.success) {
            this.setState({ editingCategoryId: null, editCategoryName: '' });
            this.reload();
        } else {
            resp.message && this.showErrorDialog(resp.message);
        }
    };

    setEditCategoryName = (editCategoryName) => this.setState({ editCategoryName });
    setEditIconNameString = (editiconNameString) => this.setState({ editiconNameString });
    setEditIconColour = (editIconColour) => this.setState({ editIconColour });

    showErrorDialog = (message) => {
        setTimeout(
            () =>
                this.setState({
                    showMessage: {
                        message: message,
                        title: 'Save error',
                        close: () => this.setState({ showMessage: null }),
                    },
                }),
            500,
        );
    };

    render() {
        return (
            <div className="maincontainer">
                <h4>Manage Knowledgebase Categories</h4>

                <CategoryItems>
                    {this.state.categories.map((category) => {
                        if (this.state.editingCategoryId !== null && this.state.editingCategoryId === category.id) {
                            return (
                                <EditCategory
                                    id={category.id}
                                    initialCategoryName={category.name}
                                    initialIconName={category.icon_name}
                                    initialIconColour={category.icon_colour}
                                    onSave={this.saveEditedCategory}
                                    onCancel={this.resetEditingCategory}
                                    editCategoryName={this.state.editCategoryName}
                                    setEditCategoryName={this.setEditCategoryName}
                                    editIconNameString={this.state.editIconNameString}
                                    setEditIconNameString={this.setEditIconNameString}
                                    editIconColour={this.state.editIconColour}
                                    setEditIconColour={this.setEditIconColour}
                                />
                            );
                        }

                        return (
                            <CategoryItem
                                id={category.id}
                                categoryName={category.name}
                                isMultiple={this.state.categories.length > 1}
                                isEditable={!category.isDefault}
                                doDelete={this.deleteCategory}
                                onEdit={() => this.openEditingCategory(category.id, category.name)}
                            />
                        );
                    })}
                </CategoryItems>

                <AddCategory
                    addingCategory={this.state.addingCategory}
                    onCancel={this.closeAddingCategory}
                    onSave={this.saveNewCategory}
                    newCategoryName={this.state.newCategoryName}
                    setNewCategoryName={(newCategoryName) => this.setState({ newCategoryName })}
                    newIconNameString={this.state.newIconNameString}
                    setNewIconNameString={(val) => this.setState({ newIconNameString: val })}
                    newiconColour={this.state.newiconColour}
                    setNewIconColour={(val) => this.setState({ newiconColour: val })}
                />

                <div className={'add-category-container'}>
                    <button onClick={this.openAddingCategory} className={'btn btn-primary add-category-button'}>
                        <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: '10px' }} />
                        ADD CATEGORY
                    </button>
                </div>
                {this.state.showMessage ? (
                    <MessageDialog
                        message={this.state.showMessage.message}
                        title={this.state.showMessage.title}
                        onClose={() => this.setState({ showMessage: null })}
                    />
                ) : null}
            </div>
        );
    }
}

const fetchFeatureFlags = async (setFlags, orgId) => {
    let featureFlags = {};
    const featureFlagResp = await get(`cms/feature_flags/${orgId}`, null, true);
    if (featureFlagResp && featureFlagResp.feature_flags) {
        featureFlags = FeatureFlagService.convertFeatureFlagsToObject(featureFlagResp.feature_flags);
    }
    setFlags(featureFlags);
};

function AddCategory(props) {
    const allIcons = { ...SolidIcons, ...RegularIcons };

    const [featureFlags, setFeatureFlags] = useState({});
    const [showCategoryIconColourDialog, setShowCategoryIconColourDialog] = useState(false);
    const [iconNameText, setIconNameText] = useState('');
    const [iconName, setIconName] = useState();
    const [iconHexCode, setIconHexCode] = useState('#717171');

    // These set the state in the class component above
    const { setNewIconNameString } = props;
    const { setNewIconColour } = props;

    useEffect(() => {
        fetchFeatureFlags(setFeatureFlags, props.orgId);
    }, []);

    if (!props.addingCategory) {
        return null;
    }

    const changeIconHandler = () => {
        // Convert the user's icon name to FA syntax
        let modifiedIconName = iconNameText
            .toLowerCase()
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join('');

        modifiedIconName = 'fa' + modifiedIconName;

        // Look up the icon
        const selectedIcon = allIcons[modifiedIconName];

        if (selectedIcon) {
            setIconName(selectedIcon);
            setNewIconNameString(modifiedIconName);
            setNewIconColour('#717171');
        } else {
            setIconName(0);
            setNewIconNameString();
            setIconNameText();
            setIconHexCode();
            setNewIconColour();
        }
    };

    const clearIconHandler = () => {
        setIconName();
        setIconNameText('');
        setNewIconNameString();
        setIconHexCode();
        setNewIconColour();
    };

    return (
        <AddCategoryContainer>
            <StyledEditText
                label="New Category Name"
                editing={'1'}
                onChange={(e) => props.setNewCategoryName(e)}
                value={props.newCategoryName}
                maxLength={40}
            />
            {featureFlags['TILED_KNOWLEDGEBASE'] && (
                <>
                    <SelectIconContainer>
                        <ClearIconButton onClick={() => clearIconHandler()}>
                            <FontAwesomeIcon icon={faTimes} color={'#000000'} size={'sm'} />
                        </ClearIconButton>
                        <IconBox>
                            {iconName == undefined && <p>No icon selected</p>}
                            {iconName !== undefined && iconName == 0 ? (
                                <p>No icon found</p>
                            ) : (
                                <FontAwesomeIcon icon={iconName} color={iconHexCode} size={'5x'} />
                            )}
                        </IconBox>
                        <IconNameContainer>
                            <StyledEditText
                                label="Icon Name"
                                editing={'1'}
                                onChange={(e) => setIconNameText(e.replace(/\s/g, '').toLowerCase())}
                                value={iconNameText}
                            />
                            <button
                                style={{ marginLeft: '-25px' }}
                                className={'btn btn-primary'}
                                onClick={() => changeIconHandler()}
                            >
                                <FontAwesomeIcon icon={faSearch} color={'#FFFFFF'} size={'lg'} />
                            </button>
                            <button
                                style={{ marginLeft: '5px' }}
                                className={'btn btn-primary'}
                                onClick={() => setShowCategoryIconColourDialog(true)}
                            >
                                <FontAwesomeIcon icon={faEyeDropper} color={'#FFFFFF'} size={'lg'} />
                            </button>
                        </IconNameContainer>
                        <p style={{ textAlign: 'center' }}>
                            <a href="https://fontawesome.com/v5/search?ic=free" target="_blank" rel="noreferrer">
                                Click here
                            </a>{' '}
                            to find an icon from the Font Awesome library, then type the name above.
                        </p>
                    </SelectIconContainer>

                    {showCategoryIconColourDialog && (
                        <ColourPickerDialog
                            title="Select color"
                            hexValOfColor={iconHexCode}
                            onSetColor={(hexVal) => {
                                setShowCategoryIconColourDialog(false);
                                setIconHexCode(hexVal);
                                setNewIconColour(hexVal);
                            }}
                            d
                            onClose={() => {
                                setShowCategoryIconColourDialog(false);
                            }}
                        />
                    )}
                </>
            )}

            <CategoryItemControlButtons>
                <SaveButton onClick={() => (props.onSave(), clearIconHandler())}>Save</SaveButton>
                <span className={'vertical-divider'}>|</span>
                <CancelButton onClick={props.onCancel}>Cancel</CancelButton>
            </CategoryItemControlButtons>
        </AddCategoryContainer>
    );
}

function EditCategory(props) {
    const allIcons = { ...SolidIcons, ...RegularIcons };

    const iconVariableToNameHandler = (faIcon) => {
        if (!faIcon || typeof faIcon !== 'string') return '';

        const trimmed = faIcon.replace(/^fa/, '');

        // Look up the icon
        const selectedIcon = allIcons[faIcon];

        setIconName(selectedIcon);

        // Convert from PascalCase to kebab-case
        return trimmed.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    };

    const [featureFlags, setFeatureFlags] = useState({});
    const [showCategoryIconColourDialog, setShowCategoryIconColourDialog] = useState(false);
    const [iconNameText, setIconNameText] = useState();
    const [iconName, setIconName] = useState();
    const [iconHexCode, setIconHexCode] = useState(props.initialIconColour);

    // These set the state in the class component above
    const { setEditIconNameString } = props;
    const { setEditIconColour } = props;

    useEffect(() => {
        fetchFeatureFlags(setFeatureFlags, props.orgId);
    }, []);

    useEffect(() => {
        if (props.initialIconName) {
            const converted = iconVariableToNameHandler(props.initialIconName);
            setIconNameText(converted);
            setEditIconColour(iconHexCode);
        }
    }, [props.initialIconName]);

    if (props.editingCategoryId === null) {
        return null;
    }

    const changeIconHandler = () => {
        // Convert the user's icon name to FA syntax
        let modifiedIconName = iconNameText
            .toLowerCase()
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join('');

        modifiedIconName = 'fa' + modifiedIconName;

        // Look up the icon
        const selectedIcon = allIcons[modifiedIconName];

        if (selectedIcon) {
            setIconName(selectedIcon);
            setEditIconNameString(modifiedIconName);
        } else {
            setIconName(0);
            setEditIconNameString();
            setIconNameText();
            setIconHexCode();
            setEditIconColour();
        }
    };

    const clearIconHandler = () => {
        setIconName();
        setIconNameText('');
        setEditIconNameString();
        setIconHexCode();
        setEditIconColour();
    };

    return (
        <EditCategoryContainer>
            <StyledEditText
                label="New Category Name"
                editing={'1'}
                onChange={(e) => props.setEditCategoryName(e)}
                value={props.editCategoryName || props.initialCategoryName}
                maxLength={40}
            />
            {featureFlags['TILED_KNOWLEDGEBASE'] && (
                <>
                    <SelectIconContainer>
                        <ClearIconButton onClick={() => clearIconHandler()}>
                            <FontAwesomeIcon icon={faTimes} color={'#000000'} size={'sm'} />
                        </ClearIconButton>
                        <IconBox>
                            {iconName == undefined && <p>No icon selected</p>}
                            {iconName !== undefined && iconName == 0 ? (
                                <p>No icon found</p>
                            ) : (
                                <FontAwesomeIcon icon={iconName} color={iconHexCode} size={'5x'} />
                            )}
                        </IconBox>
                        <IconNameContainer>
                            <StyledEditText
                                label="Icon Name"
                                editing={'1'}
                                onChange={(e) => setIconNameText(e.replace(/\s/g, '').toLowerCase())}
                                value={iconNameText}
                            />
                            <button
                                style={{ marginLeft: '-25px' }}
                                className={'btn btn-primary'}
                                onClick={() => changeIconHandler()}
                            >
                                <FontAwesomeIcon icon={faSearch} color={'#FFFFFF'} size={'lg'} />
                            </button>
                            <button
                                style={{ marginLeft: '5px' }}
                                className={'btn btn-primary'}
                                onClick={() => setShowCategoryIconColourDialog(true)}
                            >
                                <FontAwesomeIcon icon={faEyeDropper} color={'#FFFFFF'} size={'lg'} />
                            </button>
                        </IconNameContainer>
                        <p style={{ textAlign: 'center' }}>
                            <a href="https://fontawesome.com/v5/search?ic=free" target="_blank" rel="noreferrer">
                                Click here
                            </a>{' '}
                            to find an icon from the Font Awesome library, then type the name above.
                        </p>
                    </SelectIconContainer>

                    {showCategoryIconColourDialog && (
                        <ColourPickerDialog
                            title="Select color"
                            hexValOfColor={iconHexCode || '#000000'}
                            onSetColor={(hexVal) => {
                                setShowCategoryIconColourDialog(false);
                                setIconHexCode(hexVal);
                                setEditIconColour(hexVal);
                            }}
                            d
                            onClose={() => {
                                setShowCategoryIconColourDialog(false);
                            }}
                        />
                    )}
                </>
            )}
            <CategoryItemControlButtons>
                <SaveButton onClick={(e) => (props.onSave(e, props.id), clearIconHandler())}>Save</SaveButton>
                <span className={'vertical-divider'}>|</span>
                <CancelButton onClick={props.onCancel}>Cancel</CancelButton>
            </CategoryItemControlButtons>
        </EditCategoryContainer>
    );
}

const CategoryItemControlButtons = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

function CategoryItem(props) {
    const [deleting, setDeleting] = useState(false);

    const deleteDialog = deleting ? (
        <DeleteDialog
            item="Category"
            onSuccess={() => {
                setDeleting(false);
                props.doDelete(props.id);
            }}
            onClose={() => setDeleting(false)}
        />
    ) : null;

    return (
        <div className={'category-item'}>
            <CategoryLine />

            <span className={'category-item-title'}>{props.categoryName}</span>

            {props.isEditable ? (
                <div className={'category-item-control-buttons'}>
                    <EditButton onClick={props.onEdit}>Edit</EditButton>
                    <span className={'vertical-divider'}>|</span>
                    <DeleteButton onClick={() => setDeleting(true)}>Delete</DeleteButton>
                </div>
            ) : null}

            {deleteDialog}
        </div>
    );
}

const AddCategoryContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center
    justify-content: center;
    border: 2px solid #1874a7;
    border-radius: 5px;
    padding: 20px;
    gap: 10px;
    margin: 20px;
    max-width: 600px;
`;

const EditCategoryContainer = styled(AddCategoryContainer)``;

const StyledEditText = styled(EditText)`
    width: 300px;
    margin-right: 30px;
`;

const CategoryItems = styled.div`
    margin-top: 40px;
`;

const SimpleLine = styled.div`
    background-color: #d3d8dc;
    display: flex;
    height: 1px;
    width: 1px;
`;

const SimpleLineContainer = styled.div`
    flex-direction: row;
    display: flex;
    width: 40px;
    align-items: center;
    justify-content: center;
`;

const HorizontalLine = styled(SimpleLine)`
    width: 24px;
`;

const VerticalLine = styled(SimpleLine)`
    height: 40px;
    transform: translate(0px, -20px);
`;

const CategoryLine = (props) => (
    <SimpleLineContainer>
        <VerticalLine />
        <HorizontalLine />
    </SimpleLineContainer>
);

const settingButtonStyle = `
  outline:0 !important;
  background: none;
  border: none;
  font-weight: 550;
`;

const settingButtonCancelColor = `
  color: #AF365F;
`;

const settingButtonSetColor = `
  color: #1874A7;
`;

const CancelButton = styled.button`
    ${settingButtonStyle}
    ${settingButtonCancelColor}
`;

const SaveButton = styled.button`
    ${settingButtonStyle}
    ${settingButtonSetColor}
`;

const CategoryIconButton = styled.button`
    ${settingButtonStyle}
    ${settingButtonSetColor}
`;

const EditButton = styled.button`
    ${settingButtonStyle}
    ${settingButtonSetColor}
`;

const DeleteButton = styled.button`
    ${settingButtonStyle}
    ${settingButtonCancelColor}
`;

const SelectIconContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 20px;
`;

const IconBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 170px;
    height: 170px;
    padding: 10px;
    background-color: white;
    border-radius: 10px;
    user-select: none;
    cursor: default;
`;

const ClearIconButton = styled.div`
    position: relative;
    top: 25px;
    left: 85px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    background-color: #eeeeee;
    border-radius: 50%;
    user-select: none;
    cursor: pointer;
`;

const IconNameContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;
